export interface IGmbLocation {
  address?: IGmbAddress;
  languageCode?: string;
  latlng?: { latitude: number; longitude: number };
  locationKey?: IGmbLocationKey;
  locationName?: string;
  locationState?: IGmbLocationState;
  id?: string;
  metadata?: IGmbMetadata;
  name?: string;
  openInfo?: IGmbOpenInfo;
  primaryPhone?: string;
  primaryCategory?: IGmbPrimaryCategory;
  regularHours?: IGmbRegularHours;
  storeCode?: string;
  websiteUrl?: string;
  profile?: IGmbProfile;
  attributes?: any;
  title?: string;
  categories?: any[];
  storefrontAddress?: any;
  phoneNumbers?: any;
}

export interface IGmbMoreHoursType {
  hoursTypeId: string;
  displayName: string;
  localizedDisplayName: string;
}

export interface IGmbPrimaryCategory {
  displayName: string;
  categoryId: string;
  moreHoursTypes: IGmbMoreHoursType[];
}

export interface IGmbPeriod {
  openDay: string;
  openTime: string;
  closeDay: string;
  closeTime: string;
}

export interface IGmbRegularHours {
  periods: IGmbPeriod[];
}

export interface IGmbLocationKey {
  placeId: string;
  requestId: string;
}

export interface IGmbOpenInfo {
  status: string;
  canReopen: boolean;
}

export interface IGmbLocationState {
  isGoogleUpdated: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  isVerified: boolean;
  isPublished: boolean;
}

export interface IGmbMetadata {
  mapsUrl: string;
  newReviewUrl: string;
}

export interface IGmbAddress {
  regionCode: string;
  languageCode: string;
  postalCode: string;
  administrativeArea: string;
  locality: string;
  sublocality: string;
  addressLines: string[];
}

export interface IGmbProfile {
  description: string;
}
